import { getAuthModule } from '@littlebird/auth-client';
import { useCallback } from 'react';

import { getEnvVar } from '@/env';

import {
  buildSandboxTerminalWsUrl,
  describeSandboxTerminalClose,
  encodeAuthMessage,
} from './sandbox-terminal-protocol';
import { TerminalView, type TerminalConnection } from './TerminalView';

interface SandboxTerminalProps {
  /** Chat whose E2B sandbox the terminal attaches to. */
  chatId: string;
  onClose: () => void;
}

/**
 * Internal-only in-app terminal into a chat's E2B sandbox.
 *
 * Authenticates with the backend via first-message token auth - the URL carries
 * no secret; the server enforces internal + chat ownership at connection time.
 */
export function SandboxTerminal({ chatId, onClose }: SandboxTerminalProps) {
  const resolveConnection =
    useCallback(async (): Promise<TerminalConnection> => {
      const token = await getAuthModule().getAccessToken();
      return {
        wsUrl: buildSandboxTerminalWsUrl(getEnvVar('VITE_API_URL'), chatId),
        authFrame: encodeAuthMessage(token),
      };
    }, [chatId]);

  return (
    <TerminalView
      title="Sandbox terminal"
      resolveConnection={resolveConnection}
      describeClose={describeSandboxTerminalClose}
      onClose={onClose}
    />
  );
}
